import { render, staticRenderFns } from "./ThemeOrigin.vue?vue&type=template&id=503a0f40&scoped=true"
import script from "./ThemeOrigin.vue?vue&type=script&lang=js"
export * from "./ThemeOrigin.vue?vue&type=script&lang=js"
import style0 from "./ThemeOrigin.vue?vue&type=style&index=0&id=503a0f40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503a0f40",
  null
  
)

export default component.exports